import { render, staticRenderFns } from "./reportComponent.vue?vue&type=template&id=1a4356f0"
import script from "./reportComponent.vue?vue&type=script&lang=js"
export * from "./reportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports